<script lang="ts">
    import { RewardsTranslationNamespaces } from "@apps/rewards/constants/constants";
    import RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";

    import T from "@components/T.svelte";

    export let discountValue: number;
    export let pointsPrice: number;
    export let pointsName: string;
    export let rewardsCurrencyFormatter: RewardsCurrencyFormatter;
    export let namespace: RewardsTranslationNamespaces;

    const formattedCurrency$ = rewardsCurrencyFormatter.selectFormattedCurrency(
        Math.abs(discountValue)
    );
</script>

<T
    {namespace}
    translationKey="spending_rules_fixed_reward"
    translationOptions={{
        amount: $formattedCurrency$,
        points: pointsPrice,
        points_name: pointsName,
    }}
/>
